<script>
	const model = require('model/model');
	module.exports = {
		methods: {
			createClass() {
				model.set('returnToAADAH', true);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';
	@import 'mixins/flexbox';

	.aad-home-digital {
		.task-item {
			.task-content {
				margin: 0 0 1rem 2rem;
			}

			.task-instruction {
				margin: 0.5rem 0;
			}
		}
		iframe {
			width: 100%;
			height: 640px;
		}
	}

	@media print {
		.task-item,
		.task-content {
			page-break-inside: avoid;
		}
	}
</style>
<template>
	<main
		id="content"
		class="main aad-home-digital">
		<header class="main-header">
			<div class="wrapper">
				<h1 class="main-header-title">Article A Day at Home Digital</h1>
			</div>
		</header>
		<div class="main-content wrapper">
			<section>
				<div class="task-item">
					<h3>
						Did you know that the knowledge your child has about the world is one of the most important factors in their success as readers? Do this simple
						routine online to give them access to rich information about science, arts, technology, and world cultures.
					</h3>
				</div>
				<div class="task-item">
					<h3>To do Article-A-Day at Home Digitally, you'll need to create a class.</h3>
					<p class="task-content">
						<a
							href="/class-admin"
							class="button"
							@click="createClass">
							Create a Class
						</a>
					</p>
				</div>
				<iframe
					src="https://docs.google.com/presentation/d/e/2PACX-1vQRTccemnrEb6cuC2VKEpbZlcOFbMNXCUblvjEUxoD5VAr3bM4q0XSe3GBBvFh4eC10Eg5h2XXlCg9t/embed?start=false&loop=false&delayms=3000"
					frameborder="0"
					allowfullscreen="true"
					mozallowfullscreen="true"
					webkitallowfullscreen="true"></iframe>
			</section>
		</div>
	</main>
</template>
